export const theme = {
  colors: {
    primary: "#1d2c5e",
    secondary: "#34488f",
    background: "#f8f9fa",
    surface: "#ffffff",
    text: "#2c3e50",
    muted: "#4b5563",
    border: "#e5e7eb",
    warning: "#fca5a5",
    warningText: "#7f1d1d",
    success: "#10b981",
    successSoft: "#bbf7d0",
    error: "#dc2626",
    info: "#1d4ed8",
    gradientStart: "#1d2c5e",
    gradientEnd: "#34488f",
    ctaDark: "#2c3e50",
    // Dourado da logo (o sol atrás da cruz) e o marrom do lettering.
    // Amarelo é cor de DESTAQUE sobre o azul — medalha, selo, chamada. Usado em
    // área grande vira aviso de trânsito e some o contraste com o texto escuro.
    gold: "#f2b824",
    goldSoft: "#fde9b0",
    goldDark: "#c8930f",
    logoBrown: "#5c2a16",
  },
  spacing: {
    xs: "4px",
    sm: "8px",
    md: "12px",
    lg: "16px",
    xl: "24px",
  },
  radius: {
    sm: "8px",
    md: "12px",
    lg: "16px",
    pill: "50px",
  },
  fontSizes: {
    sm: "0.9rem",
    md: "1rem",
    lg: "1.2rem",
    xl: "2rem",
    xxl: "3rem",
  },
  shadows: {
    sm: "0 8px 24px rgba(0,0,0,0.1)",
    md: "0 12px 30px rgba(0,0,0,0.12)",
  },
};
